import { HttpClient } from '@angular/common/http';
import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import translationMetadata from '../../../../assets/generated/translation.json';
import { ENGLISH_LOCALE, ENGLISH_US_LOCALE } from './locale.const';

export class CustomTranslateHttpLoader implements TranslateLoader {
    constructor(private readonly http: HttpClient) {}

    /**
     * Gets the translations from the server
     */
    public getTranslation(lang: string): Observable<TranslationObject> {
        const locale = lang === ENGLISH_US_LOCALE ? ENGLISH_LOCALE : lang;
        const hash = translationMetadata.fileHashes[locale as keyof typeof translationMetadata.fileHashes];
        if (!hash) {
            console.error(`No translation file found for locale: ${locale}; falling back to ${ENGLISH_LOCALE}`);
            const fallbackHash = translationMetadata.fileHashes[ENGLISH_LOCALE];
            if (!fallbackHash) {
                throw new Error(`No translation file found for fallback locale: ${ENGLISH_LOCALE}`);
            }

            return this.http.get<TranslationObject>(`./assets/i18n/${ENGLISH_LOCALE}.json?v=${fallbackHash}`);
        }

        return this.http.get<TranslationObject>(`./assets/i18n/${locale}.json?v=${hash}`);
    }
}
